import { useState } from 'react';
import Image from 'next/image';

const PlaceholderIcon = () => (
    <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-10 h-10"
    >
        <rect x="6" y="9" width="36" height="30" rx="2.5" />
        <circle cx="17" cy="19" r="3" />
        <path d="M6 33l10-10 8 7 6-6 12 11" />
    </svg>
);

export const formatMnt = (value) =>
    '₮ ' +
    new Intl.NumberFormat('mn-MN', {
        style: 'decimal',
        minimumFractionDigits: 0,
    }).format(value || 0);

// Бүтээгдэхүүний карт (жагсаалт, нүүр, хайлт): 3:4 зураг элсэн дэвсгэр дээр,
// доор нь нэр ба үнэ — хүрээ, сүүдэргүй, энгийн.
// fluid: эх элементийнхээ өргөнийг дүүргэнэ; default: 276px тогтмол (хайлтын dropdown).
const ProductCard = (props) => {
    const [imgError, setImgError] = useState(false);

    const productName = (props.productName || []).filter(
        (item) => item.language_code === props.ChosenlangCode,
    );
    const productDescription = (props.productDescription || []).filter(
        (item) => item.language_code === props.ChosenlangCode,
    );
    const name = productName[0]?.value || '';
    const description = productDescription[0]?.value || '';
    // Баазад "нэр" нь загварын код ("11722-2370 ..."), "тайлбар" нь уншигдах нэр
    // ("Ноолууран цэлмэг хослол") тул тайлбарыг үндсэн мөр, кодыг хоёрдогч мөр болгоно
    const primary = description || name;
    const secondary = description ? name : '';

    const fluid = Boolean(props.fluid);
    const hasImage = Boolean(props.thumbnail) && !imgError;
    // Зургийн булангийн радиус: default rounded-xl, нүүр хуудас rounded-md дамжуулна
    const radius = props.radius || 'rounded-xl';

    return (
        <div
            className={`group transition-transform duration-300 ease-out hover:-translate-y-1 ${fluid ? 'w-full' : 'w-[276px]'}`}
        >
            <div
                className={`relative aspect-[3/4] ${radius} overflow-hidden bg-sand`}
            >
                {hasImage ? (
                    <Image
                        src={props.thumbnail}
                        alt={name}
                        fill
                        sizes={
                            fluid
                                ? '(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw'
                                : '276px'
                        }
                        className="object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-ink/15">
                        <PlaceholderIcon />
                    </div>
                )}
            </div>

            <div className="mt-3">
                <p
                    className="text-[13px] text-ink leading-snug truncate"
                    title={primary}
                >
                    {primary}
                </p>
                {secondary ? (
                    <p
                        className="mt-0.5 text-[11px] text-stone truncate"
                        title={secondary}
                    >
                        {secondary}
                    </p>
                ) : null}
                <p className="mt-1 text-[13px] text-ink/80">
                    {formatMnt(props.price)}
                </p>
            </div>
        </div>
    );
};

export default ProductCard;
